import { flushOfflineQueue, offlineDb } from "@/db/offlineDb";
import { syncService } from "@/lib/captainMesh/application/syncService";

/**
 * The reload button's sync (owner, 2026-10-31: "make the reload button force
 * sync the pad"). Checks the server, sends the queued till actions and every
 * order this device still owes the server — whatever its back-off — and
 * answers in the operator's words what happened (law 3).
 *
 * Returns { ok, message }: ok is false when anything is still unsent.
 */
export async function forceSyncDevice(token, checkServer) {
  const online = checkServer ? await checkServer() : true;
  if (!online) {
    return { ok: false, message: "Server not reachable from this device — nothing could be sent. Check the Wi-Fi." };
  }
  // flushOfflineQueue keeps a failed batch queued and returns quietly, so
  // what is still pending afterwards is the answer, not whether it threw.
  let queueLeft = 0;
  try {
    await flushOfflineQueue(token);
  } catch { /* counted below */ }
  try {
    queueLeft = await offlineDb.offline_sync_queue.where("status").equals("pending").count();
  } catch {
    queueLeft = -1;
  }
  const s = await syncService.forceSync();
  const parts = [];
  if (s.sent) parts.push(`${s.sent} order${s.sent === 1 ? "" : "s"} sent`);
  if (s.held) parts.push(`${s.held} held back by the server: ${s.reasons.join("; ") || "no reason given"}`);
  if (s.failed) parts.push(`${s.failed} could not be sent`);
  if (s.dropped) parts.push(`${s.dropped} capture${s.dropped === 1 ? "" : "s"} not sent (empty, or older than 12 hours and set aside)`);
  if (queueLeft > 0) parts.push(`${queueLeft} queued action${queueLeft === 1 ? "" : "s"} still waiting for the server`);
  if (queueLeft < 0) parts.push("could not read this device's queue");
  const ok = !s.held && !s.failed && !s.dropped && queueLeft === 0;
  return { ok, message: parts.length ? parts.join(" · ") : "Everything on this device is already with the server." };
}
